import React, { useEffect, useState } from "react";
import HallOfFameCategoryBox from "./hallOfFameCategoryBox";
import HallOfFameUserModal from "./hallOfFameUserModal";
import { getHallOfFameUsers } from "../../db/firebaseMethods";

// Kayıtlar admin panelindeki "Final Puanları" sekmesinden sıralamalar
// kaydedilince otomatik oluşur/güncellenir.
const CATEGORY_ORDER = [
  "Minikler",
  "Çocuklar",
  "Gençler",
  "Yetişkinler",
  "Emektarlar",
];

const HallOfFame2026 = ({ selectedUser, onShowFull, onModalClose }) => {
  const season = "oyun2026";
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    getHallOfFameUsers(season).then((users) => {
      // Sezona ait kategori adları farklı olursa da listede görünsünler
      const categories = [
        ...CATEGORY_ORDER,
        ...new Set(
          users
            .map((u) => u.category)
            .filter((c) => !CATEGORY_ORDER.includes(c))
        ),
      ];
      setAllUsers(
        categories
          .map((c) => ({
            title: c.toLocaleUpperCase("tr"),
            users: users.filter((u) => u.category === c),
          }))
          .filter((c) => c.users.length > 0)
      );
    });
  }, []);

  const header = (
    <div
      className="header"
      style={{ background: "radial-gradient(#e1e1e1,#b4aad3)" }}
    >
      OYUN 2026 Şeref Kürsüsü
    </div>
  );
  return (
    <div className="hallOfFame">
      {header}

      {allUsers.map((category) => (
        <HallOfFameCategoryBox
          key={"category_box" + category.title}
          title={category.title}
          users={category.users}
          onShowFull={onShowFull}
        />
      ))}
      {selectedUser && (
        <HallOfFameUserModal
          selectedUser={selectedUser}
          onModalClose={onModalClose}
        />
      )}
    </div>
  );
};

export default HallOfFame2026;
